export default function(h) {
  return h(
    'div',
    {
      class: this.$_class
    },
    this.$slots.default
  )
}
